export const version = 'v5.6.0';
export const buildDate = '2026-07-14T23:54:39.243Z';
export const commitHash = '1cae3d6';